
import { Component, Mixins } from "vue-property-decorator";
import OfficeNewUser from "../office-new-user.vue";
import ConfirmDialog from "@/common/components/confirm-modal.vue";
import ValidatedFormMixin from "@/common/mixins/validated-form.mixin";
import AuthMixin from "@/common/mixins/auth.mixin";
import OfficeProfileMixin from "../../office-profiles.mixin";
import { OfficeUserDto, OfficeDataDto, OfficeUserFormDto } from "@/types/office.type";
import { Roles } from "@/types/enums.type";
import { StatusNames } from "@/common/constants";
import { mapState } from "vuex";

 @Component({
  components: {
    OfficeNewUser,
    ConfirmDialog
  },
  computed: {
    ...mapState("OfficeProfile", ["officeData", "officeUsers"])
  }
})
export default class OfficeStaffEditComponent extends Mixins(OfficeProfileMixin, AuthMixin, ValidatedFormMixin) {
  officeData!: OfficeDataDto;

  officeUsers!: OfficeUserDto[];

  modalShow = false;
  confirmModalShow = false;
  selectedIndex = 0;

  StatusNames = StatusNames;

  isUserDisabled(user: OfficeUserDto): boolean {
    return user.roleName === Roles.PracticeUser || user.userId === this.userInfo()?.sub;
  }

  async mounted(): Promise<void> {
    const userInfo = this.userInfo();

    if (!userInfo) {
      this.$store.commit("OfficeProfile/updateField", {
        path: "errorMessage",
        value: "Failed to fetch user info."
      });

      return;
    }

    await this.$store.dispatch("OfficeProfile/getOfficeUsers", {
      practiceId: userInfo.practiceId,
      currentUserId: userInfo.sub
    } as { practiceId: number, currentUserId: number });

    this.$validator.reset();
  }

  showUserCreateModal(): void {
    this.$store.commit("OfficeProfile/updateField", {
      path: "errorMessage",
      value: null
    });

    this.modalShow = true;
  }

  async onStatusChange(user: OfficeUserDto): Promise<void> {
    if (!this.selectedOffice) {
      user.officeUserStatus = user.officeUserStatus === StatusNames.Enabled.getId(this.officeData.statuses) ? StatusNames.Disabled.getId(this.officeData.statuses) : StatusNames.Enabled.getId(this.officeData.statuses);

      return;
    }

    this.setLoading(true);

    user.officeUserStatus = user.officeUserStatus === StatusNames.Enabled.getId(this.officeData.statuses) ? StatusNames.Disabled.getId(this.officeData.statuses) : StatusNames.Enabled.getId(this.officeData.statuses);

    await this.saveUser(user);

    this.setLoading(false);
  }

  async saveUser(user: OfficeUserDto): Promise<void> {
    if (!this.selectedOffice) {
      return;
    }

    await this.$store.dispatch("OfficeProfile/saveOfficeUser", {
      userId: user.userId,
      officeId: this.selectedOffice.id,
      status: user.officeUserStatus
    } as OfficeUserFormDto);
  }

  async onUserCreateSuccess(user: OfficeUserDto): Promise<void> {
    if (this.isEdit) {
      if (!this.selectedOffice) {
        this.$store.commit("OfficeProfile/updateField", {
          path: "errorMessage",
          value: "Error fetching users."
        });

        return;
      }

      const office = {...this.selectedOffice};

      office.users.push(user);

      this.$store.commit("OfficeProfile/updateField", {
        path: "selectedOffice",
        value: office
      }); 

      const officeUsers = [ ...office.users ];

      this.$store.commit("OfficeProfile/updateField", {
        path: "officeUsers",
        value: officeUsers
      });

      await this.saveUser(user);
    } else {
      const officeUsers = [...this.officeUsers, user];
      
      this.$store.commit("OfficeProfile/updateField", {
        path: "officeUsers",
        value: officeUsers
      }); 
    }
  }

  back(): void {
    this.$emit('update:activeTab', 0);
  }

  tryNext(): void {
    if (this.officeUsers.some(user => user.officeUserStatus === StatusNames.Enabled.getId(this.officeData.statuses))) {
      this.next();
    }
    else {
      this.confirmModalShow = true;
    }
  }

  next(): void {
    this.$emit('update:activeTab', 2);
  }
}
